import { createClient } from '@sanity/client';
import { config } from './config';

if (!config.projectId) {
  throw Error('The Project ID is not set. Check your environment variables.');
}

// Production client: only published documents, so drafts can never leak into a
// statically generated (indexed) page.
export const client = createClient({ ...config, perspective: 'published' });

// The preview client reads drafts, so it needs a token and must skip the CDN.
// `perspective: 'drafts'` presents draft content merged over published, returning
// a single document per id (no manual `drafts.` filtering needed downstream).
export const previewClient = createClient({
  ...config,
  useCdn: false,
  perspective: 'drafts',
  token: process.env.SANITY_PREVIEW_SECRET,
});

export const getClient = usePreview => usePreview ? previewClient : client;

export default client;
